/* Fashion CITY — 견적 폼 목업 일러스트
   ★ 옷 모양·문구 자리·로고 크기를 손볼 때는 이 파일만 고치면 됩니다.

   parts : SVG 조각들. role 이 하는 일 —
     body  : 손님이 고른 제품 색상으로 칠해집니다
     shade : 같은 색을 조금 어둡게 (주머니, 챕 같은 곳)
     line  : 선만 그립니다
   spots : 문구가 놓이는 자리.
     x, y  : 200x200 기준 좌표 (왼쪽 위가 0,0)
     w     : Medium 일 때의 폭
     sizes : [Small, Medium, Large] 의 실제 인치. 미리보기는 이 비율대로 커지고 작아집니다.
*/
window.FC_SHAPES = {
  tee: {
    label: 'T-Shirt',
    parts: [
      { role: 'body', d: 'M76,30 C76,45 124,45 124,30 L148,37 L187,71 L160,101 L147,89 L147,181 L53,181 L53,89 L40,101 L13,71 L52,37 Z' },
      { role: 'line', d: 'M76,30 C80,44 120,44 124,30' }
    ],
    spots: [
      { v: 'Left chest', x: 74, y: 72, w: 34, sizes: [3, 4, 5] },
      { v: 'Full front', x: 100, y: 106, w: 78, sizes: [8, 10, 12] }
    ]
  },
  crew: {
    label: 'Sweatshirt',
    parts: [
      { role: 'body', d: 'M74,32 C74,48 126,48 126,32 L150,40 L189,78 L161,108 L148,96 L148,178 L52,178 L52,96 L39,108 L11,78 L50,40 Z' },
      { role: 'shade', d: 'M52,178 L148,178 L148,190 L52,190 Z' },
      { role: 'line', d: 'M74,32 C80,48 120,48 126,32' }
    ],
    spots: [
      { v: 'Left chest', x: 74, y: 74, w: 34, sizes: [3, 4, 5] },
      { v: 'Full front', x: 100, y: 106, w: 78, sizes: [8, 10, 12] }
    ]
  },
  hoodie: {
    label: 'Hoodie',
    parts: [
      { role: 'body', d: 'M72,40 C78,58 122,58 128,40 L152,48 L190,86 L162,114 L149,102 L149,182 L51,182 L51,102 L38,114 L10,86 L48,48 Z' },
      { role: 'shade', d: 'M72,40 C68,14 132,14 128,40 C116,54 84,54 72,40 Z' },
      { role: 'shade', d: 'M69,136 L131,136 L131,170 L69,170 Z' },
      { role: 'line', d: 'M92,48 L94,72 M108,48 L106,72' },
      { role: 'shade', d: 'M51,182 L149,182 L149,192 L51,192 Z' }
    ],
    spots: [
      { v: 'Left chest', x: 74, y: 82, w: 34, sizes: [3, 4, 5] },
      { v: 'Full front', x: 100, y: 108, w: 76, sizes: [8, 10, 12] }
    ]
  },
  cap: {
    label: 'Baseball Cap',
    parts: [
      { role: 'body', d: 'M28,116 C28,58 172,58 172,116 Z' },
      { role: 'shade', d: 'M22,116 C22,106 178,100 194,120 C168,142 60,148 22,116 Z' },
      { role: 'line', d: 'M100,60 L100,116 M62,66 C70,88 68,102 66,116 M138,66 C130,88 132,102 134,116' }
    ],
    spots: [
      { v: 'Front panel', x: 100, y: 92, w: 58, sizes: [2, 3, 4] },
      { v: 'Side', x: 52, y: 100, w: 24, sizes: [1.5, 2, 2.5] }
    ]
  },
  trucker: {
    label: 'Trucker Hat',
    parts: [
      { role: 'body', d: 'M28,116 C28,58 172,58 172,116 Z' },
      { role: 'shade', d: 'M22,116 C22,106 178,100 194,120 C168,142 60,148 22,116 Z' },
      { role: 'line', d: 'M100,60 L100,116 M124,64 C132,84 134,100 136,116 M148,72 C156,90 158,104 160,116' }
    ],
    spots: [
      { v: 'Front panel', x: 74, y: 92, w: 56, sizes: [2, 3, 4] },
      { v: 'Side', x: 146, y: 100, w: 22, sizes: [1.5, 2, 2.5] }
    ]
  },
  tote: {
    label: 'Tote Bag',
    parts: [
      { role: 'body', d: 'M48,74 L152,74 L152,186 L48,186 Z' },
      { role: 'line', d: 'M70,74 C70,42 130,42 130,74' },
      { role: 'shade', d: 'M48,74 L152,74 L152,84 L48,84 Z' }
    ],
    spots: [
      { v: 'Front', x: 100, y: 130, w: 62, sizes: [5, 8, 10] }
    ]
  }
};
